import { DocumentItemSkeleton } from './DocumentItemSkeleton';

export const DocumentItemsListSkeleton = () => (
  <div data-testid="document-items-list-skeleton">
    <DocumentItemSkeleton />
    <DocumentItemSkeleton />
  </div>
);
